import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import * as React from 'react';
import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import { computed } from 'mobx';
import getFilteredTimeFormatOptions from '../utils/getFilteredTimeFormatOptions';
import selectTimeFormatOption from '../data/mutators/selectTimeFormatOption';
import strings from 'owa-strings/owa-options-strings';
import { formatDate } from 'owa-datetime-format';
var EXAMPLE_START_RANGE = new Date(2017, 8, 1, 1, 1);
var EXAMPLE_END_RANGE = new Date(2017, 8, 1, 23, 59);
var TimeFormatSelection = /** @class */ (function (_super) {
    tslib_1.__extends(TimeFormatSelection, _super);
    function TimeFormatSelection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectDateFormat = function (item) {
            if (_this.props.onSave) {
                _this.props.onSave(item.key);
            }
            else {
                selectTimeFormatOption(item.key);
            }
        };
        return _this;
    }
    TimeFormatSelection.prototype.render = function () {
        var savedTimeFormat = getUserConfiguration().UserOptions.TimeFormat;
        var selectedKey = getRegionalOptions().selectedTimeFormat || savedTimeFormat;
        if (getFilteredTimeFormatOptions().indexOf(selectedKey) === -1) {
            selectedKey =
                getFilteredTimeFormatOptions().indexOf(savedTimeFormat) === -1
                    ? getFilteredTimeFormatOptions()[0]
                    : savedTimeFormat;
        }
        return (React.createElement(Dropdown, { label: strings.option_regional_timeFormat, options: this.timeFormatOptions, selectedKey: selectedKey, onChanged: this.onSelectDateFormat }));
    };
    Object.defineProperty(TimeFormatSelection.prototype, "timeFormatOptions", {
        get: function () {
            return getFilteredTimeFormatOptions().map(function (shortTimeFormat) {
                return {
                    text: formatDate(EXAMPLE_START_RANGE, shortTimeFormat, false) + " - " + formatDate(EXAMPLE_END_RANGE, shortTimeFormat, false),
                    key: shortTimeFormat,
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], TimeFormatSelection.prototype, "timeFormatOptions", null);
    TimeFormatSelection = tslib_1.__decorate([
        observer
    ], TimeFormatSelection);
    return TimeFormatSelection;
}(React.Component));
export default TimeFormatSelection;
//# sourceMappingURL=TimeFormatSelection.js.map